import React from "react"
import "../Sass/navbar.css"

const Navbar = ({ handleClick }) => {
  const Links = ["home", "about", "services", "work", "contact"]

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark pb-1 sticky-top">
      <div className="container">
        <a className="navbar-brand" href="#home">
          Hardik
        </a>
        <button
          className="navbar-toggler ml-auto"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            {Links.map((Link, index) => {
              return (
                <li className="nav-item" key={index}>
                  <button
                    id={`${Link}${index}`}
                    className="nav-link btn"
                    onClick={handleClick}>
                    {Link}
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
